import React from 'react';

import { ExportTestCasesProvider } from '@qality/common-components/src/lib/ExportTestCasesProvider';
import { QAlityPageConfigurationProvider } from '@qality/common-components/src/lib/QAlityPageConfiguration';
import {
  TestCaseRepositoryFiltersProvider,
  TestCaseRepositoryIssuesProvider,
} from '@qality/common-pages/src/TestCaseRepositoryPage';

import { TestTypeProvider } from '../TestTypesPage/TestTypesProvider';
import { TestCaseRepository } from './TestCaseRepository';
import TestCaseRepositoryBulkBarProvider from './TestCaseRepositoryBulkBar/TestCaseRepositoryBulkBarProvider';
import { TestCaseRepositoryDnd } from './TestCaseRepositoryDnd';
import {
  TestCaseRepositoryFoldersContext,
  TestCaseRepositoryFoldersProvider,
} from './TestCaseRepositoryFoldersProvider';
import { TestCaseRepositoryIssueTypesProvider } from './TestCaseRepositoryIssueTypesProvider';
import { TestCaseRepositoryModalsProvider } from './TestCaseRepositoryModalsProvider';
import { TestCaseRepositorySelectionProvider } from './TestCaseRepositorySelectionProvider';

export default function TestCaseRepositoryPage(): JSX.Element {
  return (
    <QAlityPageConfigurationProvider>
      <TestCaseRepositoryFiltersProvider>
        <TestCaseRepositoryFoldersProvider>
          <TestCaseRepositoryFoldersContext.Consumer>
            {({ currentFolder }) => (
              <TestCaseRepositorySelectionProvider>
                <TestCaseRepositoryIssueTypesProvider>
                  <TestCaseRepositoryIssuesProvider folder={currentFolder}>
                    <TestCaseRepositoryModalsProvider>
                      <ExportTestCasesProvider>
                        <TestTypeProvider>
                          <TestCaseRepositoryBulkBarProvider>
                            <TestCaseRepositoryDnd>
                              <TestCaseRepository />
                            </TestCaseRepositoryDnd>
                          </TestCaseRepositoryBulkBarProvider>
                        </TestTypeProvider>
                      </ExportTestCasesProvider>
                    </TestCaseRepositoryModalsProvider>
                  </TestCaseRepositoryIssuesProvider>
                </TestCaseRepositoryIssueTypesProvider>
              </TestCaseRepositorySelectionProvider>
            )}
          </TestCaseRepositoryFoldersContext.Consumer>
        </TestCaseRepositoryFoldersProvider>
      </TestCaseRepositoryFiltersProvider>
    </QAlityPageConfigurationProvider>
  );
}
